import { FunctionComponent, useState } from 'react';
import { Button, Menu, MenuItem, ListItemIcon, ListItemText } from '@mui/material';
import { AddOutlined, ArrowDropDown, SwapHoriz, Edit } from '@mui/icons-material';
import { TransactionType } from '../api/transactions/transaction.contracts';
import { useTranslation } from '@/lib';
import { getTransactionTypeStyle } from '../types/TransactionModel';

interface TransactionTypeSelectorProps {
  onTypeSelected: (type: TransactionType) => void;
}

export const TransactionTypeSelector: FunctionComponent<TransactionTypeSelectorProps> = ({ onTypeSelected }) => {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleTypeSelect = (type: TransactionType) => {
    onTypeSelected(type);
    handleClose();
  };

  return (
    <>
      <Button
        variant="contained"
        startIcon={<AddOutlined />}
        endIcon={<ArrowDropDown />}
        onClick={handleClick}
        aria-controls={open ? 'transaction-type-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
      >
        {t('create')}
      </Button>
      <Menu
        id="transaction-type-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        slotProps={{
          list: {
            'aria-labelledby': 'transaction-type-button',
          },
        }}
      >
        <MenuItem onClick={() => handleTypeSelect(TransactionType.Transfer)}>
          <ListItemIcon>
            <SwapHoriz fontSize="small" className={`${getTransactionTypeStyle(TransactionType.Transfer).text}`} />
          </ListItemIcon>
          <ListItemText>{t('transfer')}</ListItemText>
        </MenuItem>
        <MenuItem onClick={() => handleTypeSelect(TransactionType.Correction)}>
          <ListItemIcon>
            <Edit fontSize="small" className={`${getTransactionTypeStyle(TransactionType.Correction).text}`} />
          </ListItemIcon>
          <ListItemText>{t('correction')}</ListItemText>
        </MenuItem>
      </Menu>
    </>
  );
};
